module.exports = __webpack_public_path__ + "img/ggx.8d766316.png";